module.exports = __webpack_public_path__ + "static/media/practice_aid_logo.dec60af6.png";